import helpers from './helpers.js';

export default (function () {
  return {
    focusedTab: 0,
    containers: [...document.querySelectorAll('.js-tab-container')],
    init() {
      this.handleKeyboard(this.containers);
      this.handleTabClick(this.containers);
    },

    updateTabFocus(container) {
      const tabs = [...container.querySelectorAll('[role="tab"]')];

	  helpers.forEach(tabs, (i, tab) => {
		  tab.setAttribute('tabindex', -1);
	  });

      tabs[this.focusedTab].setAttribute('tabindex', 0);
      tabs[this.focusedTab].focus();
    },

    handleTabClick(containers) {
      helpers.forEach(containers, (i, containeritem) => {
        const tabs = [...containeritem.querySelectorAll('[role="tab"]')];
        const panels = [...containeritem.querySelectorAll('[role="tabpanel"]')];
        helpers.forEach(tabs, (n, tab) => {
          tab.addEventListener('click', (e) => {
			  const { target } = e;
			  const parent = target.closest('.js-tab-container');
			  const selectedIndex = tabs.indexOf(target);
			  const selectedPanelID = target.getAttribute('aria-controls');
			  const selectedPanel = parent.querySelector(`#${selectedPanelID}`);
			  // remove aria-selected on other tabs
			  helpers.forEach(tabs, (t, tabitem) => {
				  tabitem.setAttribute('aria-selected', false);
			  });
			  target.setAttribute('aria-selected', true);

			  // set hidden on other panels
			  helpers.forEach(panels, (p, panel) => {
				  panel.setAttribute('hidden', true);
			  });
			  selectedPanel.removeAttribute('hidden');
			  this.focusedTab = selectedIndex;
			  this.updateTabFocus(containeritem);
          });
        });
      });
    },

    handleKeyboard(containers) {
      helpers.forEach(containers, (i, containeritem) => {
        const tabList = containeritem.querySelector('[role="tablist"]');
        const tabs = [...containeritem.querySelectorAll('[role="tab"]')];
        tabList.addEventListener('keydown', (e) => {
          const { key } = e;

          if (key === 'ArrowRight' || key === 'ArrowLeft') {
            if (key === 'ArrowRight') {
              this.focusedTab += 1;
              if (this.focusedTab >= tabs.length) {
                this.focusedTab = 0;
              }
            } else if (key === 'ArrowLeft') {
              this.focusedTab -= 1;
              if (this.focusedTab < 0) {
                this.focusedTab = tabs.length - 1;
              }
            }
            this.updateTabFocus(containeritem);
          }
        });
      });
    },
  };
})();
